module.exports = __webpack_public_path__ + "static/images/cog.38f7ab5270fa4ffeb63d79bef59e54ea.svg";